import { closeModal } from "./modal.js";
import { renderTrigger } from "./trigger-renderer.js";
import { resolveModalConfig } from "../shared/config.js";

import type { FormVueModalOptions } from "../shared/schema-types.js";

const FormVue = {
  button(target: string | HTMLElement, options: FormVueModalOptions): void {
    const el = typeof target === "string" ? document.querySelector<HTMLElement>(target) : target;
    if (!el) { console.error(`FormVue: target element not found: ${target}`); return; }
    if (!options.formId) { console.error("FormVue: formId is required"); return; }
    if (!options.id) { console.error("FormVue: id is required"); return; }
    if (el.shadowRoot) this.destroy(el);

    const config = resolveModalConfig(options);
    renderTrigger(el, config);
  },

  destroy(target: string | HTMLElement): void {
    const el = typeof target === "string" ? document.querySelector<HTMLElement>(target) : target;
    closeModal(el ?? undefined);
    if (!el) return;
    (el as any).__fvUnmount?.();
    delete (el as any).__fvUnmount;
    if (el.shadowRoot) el.shadowRoot.innerHTML = "";
    el.style.removeProperty("display");
    el.style.removeProperty("width");
  },

  update(target: string | HTMLElement, options: FormVueModalOptions): void {
    this.destroy(target);
    this.button(target, options);
  },
};

export { FormVue };
export { openModal, closeModal } from "./modal.js";
export type { FormVueModalOptions } from "../shared/schema-types.js";
export type { ModalConfig, EmbedContext } from "../shared/types.js";
